<template>
   <div class="row" style="padding-left:15px;padding-right:15px;margin-top:2em">
        <div class="col-md-12 content-item">
            <div class="col-item-zero flex j-center">
                <span>Овог нэр</span>
            </div>
            <div class="col-item-one flex j-center">
                <span>Картын дугаар</span>
            </div>
            <div class="col-item-two flex j-center">
                <span>Төлөв</span>
            </div>
        </div>
        
        <div class="col-md-12 content-content" style="padding:0" v-for="item in partner">
            <div class="content-content-inner col-md-12" style="box-shadow:none">
                <div class="col-item-zero flex j-center">
                    <span>{{item.firstName}}</span>
                </div>
                <div class="col-item-one flex j-center">
                    <span style="color:inherit">{{item.cardId}}</span>
                </div>
                <div class="col-item-two flex j-center">
                    <span class="text-center">{{dvip(item)}}</span>
                </div>
            </div>
        </div> 
    </div>
    
</template>

<script>
export default {
  props: ["partner"],
  methods:{
      dvip:(item) =>{
          return item.dvip == 'A' ? 'Бонус хасна' : 'Бонус нэмнэ хасна';
      }
  }
};
</script>

<style>
</style>